import React from 'react'
import { useNavigate } from 'react-router-dom'
import SlideShow from './SlideShow';

function Photo() {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/Photo');
    };

    return (
        <div onClick={handleClick} class="bbox" id="photo">
            <h2 class="box-title">PHOTOGRAPHY</h2>
            <SlideShow />
        </div>
    )
}

export default Photo